import React from 'react';
import PropTypes from 'prop-types';

import RatingV5 from './RatingV5';
import { ratingTypes } from '../../../utils/constants';

import styles from './ratingDisplayV5.scss';

const ColorballRating = (props) => {
    const { profileData, isOwnProfile, 'data-testid': dataTestId } = props;
    const { pbrRatingProgress } = profileData;

    if (profileData.pbrRatingDisplay) {
        return (
            <div className={styles.utrRange} data-testid={dataTestId ? `${dataTestId}.container` : undefined}>
                <RatingV5
                    title={ratingTypes.colorBall}
                    titleColor="blue"
                    ballColor={profileData.pbrRatingDisplay.pbrBallColor}
                    value={profileData.pbrRatingDisplay.ratingDisplay}
                    showColorBall={profileData.pbrRatingDisplay.value}
                    footer={''}
                    showRatingInfo
                    data-testid={dataTestId ? `${dataTestId}.rating` : undefined}
                />
            </div>
        );
    }
    if (profileData.utrRange?.pbrRange) {
        return (
            <RatingV5
                title={ratingTypes.colorBall}
                titleColor="blue"
                ballColor={profileData.utrRange.pbrRange.pbrBallColor}
                value={profileData.utrRange.pbrRange.ratingDisplay}
                showColorBall={profileData.utrRange.pbrRange.value}
                footer={isOwnProfile && pbrRatingProgress ? pbrRatingProgress : ''}
                showRatingInfo
                data-testid={dataTestId ? `${dataTestId}.range` : undefined}
            />
        );
    }
    return null;
};

ColorballRating.propTypes = {
    profileData: PropTypes.instanceOf(Object).isRequired,
    isOwnProfile: PropTypes.bool.isRequired,
};

export default ColorballRating;
